import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { HiChevronUp, HiChevronDown } from "react-icons/hi2";

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(31, 31, 31, 1);
  border-radius: 6px;
  background-color: var(--primary-color);
  min-width: 190px;
  overflow: hidden;
  transition: 0.2s;
  width: 100%;
  &:hover,
  &:active {
    transition: 0.2s;
    border-color: white;
  }
`;

const BeforeContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: var(--text-secondary-color);
  font-size: 13px;
  flex-shrink: 0;
`;

const NumberInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  padding: 10px 12px;
  font-size: 13px;
  background-color: transparent;
  color: var(--text-color);
  text-align: left;
  font-weight: 500;
  font-family: 'Onest', sans-serif;
`;

const StepControls = styled.div`
  display: flex;
  flex-direction: column;
`;

const StepButton = styled.button`
  border: none;
  background: transparent;
  padding: 2px 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);

  &:active {
    color: var(--text-active-color);
  }
`;

type FloatInputProps = {
  value: number;
  step?: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  before?: React.ReactNode; // 👈 Новый проп
};

export const FloatInput: React.FC<FloatInputProps> = ({
  value,
  step = 0.1,
  min,
  max,
  onChange,
  before,
}) => {
  const [inputValue, setInputValue] = useState(value.toString());

  useEffect(() => {
    setInputValue(value.toString());
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const commitValue = () => {
    let newVal = parseFloat(inputValue);
    if (isNaN(newVal)) newVal = 0;
    if (min !== undefined) newVal = Math.max(newVal, min);
    if (max !== undefined) newVal = Math.min(newVal, max);
    onChange(parseFloat(newVal.toFixed(2)));
  };

  const increment = () => {
    let newVal = value + step;
    if (max !== undefined) newVal = Math.min(newVal, max);
    onChange(parseFloat(newVal.toFixed(2)));
  };

  const decrement = () => {
    let newVal = value - step;
    if (min !== undefined) newVal = Math.max(newVal, min);
    onChange(parseFloat(newVal.toFixed(2)));
  };

  return (
    <InputWrapper>
      {before && <BeforeContainer>{before}</BeforeContainer>}
      <NumberInput value={inputValue} onChange={handleChange} onBlur={commitValue} />
      <StepControls>
        <StepButton onClick={increment}>
          <HiChevronUp size={12} />
        </StepButton>
        <StepButton onClick={decrement}>
          <HiChevronDown size={12} />
        </StepButton>
      </StepControls>
    </InputWrapper>
  );
};
